import {
  Select as SelectMantine,
  SelectProps,
  useMantineTheme,
} from "@mantine/core";
import { ArrowDown2 } from "iconsax-react";
import { useTranslation } from "react-i18next";

const Select = (props: SelectProps) => {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  return (
    <SelectMantine
      mt={-8}
      styles={{ rightSection: { pointerEvents: "none" } }}
      aria-label="select"
      dropdownPosition="bottom"
      rightSection={<ArrowDown2 size="24" color={theme.colors.basic[5]} />}
      {...props}
      data={props.data.map((item: any) => ({
        ...item,
        label: t(item.label),
        value: item.value,
      }))}
    />
  );
};

export default Select;
